<template>
	<div class="page with-logo">
		<div class="logo-text">
			<div>
				<button @click="goToWithSeeds('search')" class="button back"/>
			</div>
		</div>
		<h1>Anything else?</h1>
		<p>Don’t forget - you can now add more events from the same or different artists</p>
		<Basket
			:showAddMoreEventsButton="true"
			:basket-entities="basketEntities"
			@remove="removeEntityFromBasket"
			@goToSearch="goToWithSeeds('search')"
			@goToConfigure="goToWithSeeds('configure')"
			/>
	</div>
</template>

<script>
  import Basket from '../Basket'
  import basketHolderMixin from '../../mixins/basketHolder.js'

  export default {
    mixins : [
      basketHolderMixin
    ],
    components : { Basket },
  }
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/var';

.basket {
	margin-bottom: $gap-large;
}
</style>
